export enum HEADER {
    /**
     * @value Create
     * @description Label of the top bar button used to open the contribution menu.
     * Clicking on this button displays a menu used to create a new post or a new content
     */
    CREATE_BUTTON = 'FRONT.CONTRIBUTION_MENU.CREATE_BUTTON',
    /**
     * @value New content
     * @description Title of the second section of the contribution menu
     */
    NEW_CONTENT = 'FRONT.CONTRIBUTION_MENU.NEW_CONTENT',
    /**
     * @value New post
     * @description title of the first section in the contribution menu
     */
    NEW_POST = 'FRONT.CONTRIBUTION_MENU.NEW_POST',
    /**
     * @value New space
     * @description Button to create a new space
     * The term "Space" must not be translated, it is a male name.
     */
    NEW_SPACE = 'SPACES.NEW_SPACE',
    /**
     * @value Open the navigation menu
     * @description Text used in a tooltip to describe the behavior of the action
     */
    OPEN_NAVIGATION = 'FRONT.OPEN_NAVIGATION',
    /**
     * @value Post
     * @description Name of the standard/basic type of post.
     */
    POST_TYPE_DEFAULT = 'FRONT.COMMUNITY.POST.TYPE.DEFAULT',
}
